module.exports = __webpack_public_path__ + "img/L_314_0.a13c78c3.png";